import * as React from 'react';
import { ArticleParagraph1 } from '@cian/ui-kit';

import { SideBar } from '../../components/SideBar/SideBar';
import { SIDEBAR_TITLE, SIDEBAR_BACK_LOCATION, SIDEBAR_BACK_TEXT, SIDEBAR_MESSAGE } from './constants';
import { BackToPage } from '../../components/BackToPage';
import { useSideBarTracking } from './utils';

export const SideBarContainer: React.FC = () => {
  const { trackBackToPage } = useSideBarTracking();

  return (
    <SideBar
      header={<BackToPage text={SIDEBAR_BACK_TEXT} href={SIDEBAR_BACK_LOCATION} onClick={trackBackToPage} />}
      title={SIDEBAR_TITLE}
    >
      <ArticleParagraph1>{SIDEBAR_MESSAGE}</ArticleParagraph1>
    </SideBar>
  );
};

SideBarContainer.displayName = 'SideBarContainer';
